import { PICTOGRAM_TYPES } from '../../constants/pictogram-types'
import mechanical from './mechanical'
import electrical from './electrical'
import trenches from './trenches'
import buriedEvacuation from './buried-evacuation'
import aerialEvacuation from './aerial-evacuation'

/**
 * Registro de PERFILES DE VISOR por tipo de pictograma. Cada perfil declara el
 * comportamiento por modo (design/progress): flujo de carga, captura, resumen,
 * avance lineal, etc. El orquestador (CadStudio) lee el perfil y monta solo eso,
 * en vez de ramificar con if/else por tipo.
 *
 * Añadir un tipo nuevo = crear su archivo en profiles/ y registrarlo aquí.
 * DATA-ONLY: no importa componentes ni toca el engine.
 */
export const PROFILES = {
  [PICTOGRAM_TYPES.MECHANICAL]:        mechanical,
  [PICTOGRAM_TYPES.ELECTRICAL]:        electrical,
  [PICTOGRAM_TYPES.DITCHES]:           trenches,
  [PICTOGRAM_TYPES.BURIED_EVACUATION]: buriedEvacuation,
  [PICTOGRAM_TYPES.AERIAL_EVACUATION]: aerialEvacuation,
}

/** Perfil para un tipo; cae a mecánico si el tipo no está registrado. */
export function getProfile(type) {
  return PROFILES[type] || mechanical
}
